import { baseApi } from "./baseApi";

export interface CompanyXp {
  total_xp: number;
  current_level: number;
  xp_to_next_level: number;
  /** Levels gained since the start of the current JST month (>= 0). */
  levels_gained_this_month: number;
}

export interface MyXpResponse {
  data: CompanyXp;
  message: string;
  success: boolean;
}

const MY_XP_URL = "/gamification/me/xp";
const companyXpUrl = (companyCode: string) =>
  `/gamification/companies/${companyCode}/xp`;

export const expApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyXp: builder.query<MyXpResponse, void>({
      query: () => ({ url: MY_XP_URL }),
      providesTags: ["Xp"],
    }),
    // XP for a company by its public code — used by the public profile so a
    // viewer sees the viewed company's XP rather than their own (me/xp).
    getCompanyXp: builder.query<MyXpResponse, { companyCode: string }>({
      query: ({ companyCode }) => ({ url: companyXpUrl(companyCode) }),
      providesTags: (_result, _error, { companyCode }) => [
        { type: "Xp", id: companyCode },
      ],
    }),
  }),
});

export const { useGetMyXpQuery, useGetCompanyXpQuery } = expApi;
